var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{class:_vm.noBottomMarg ? 'mb-0' : 'mb-3',attrs:{"variant":"warning","show":_vm.errors.length > 0}},[_vm._l((_vm.errors),function(error,i){return _c('div',{key:i},[_vm._v(_vm._s(error))])}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }